import { apiClient } from "@/services/apiClient";

export type DeelConnectionStatus =
  | "active"
  | "disconnected"
  | "error"
  | "not_connected";

export interface DeelStatus {
  connected: boolean;
  status: DeelConnectionStatus;
  connectedAt: string | null;
  lastSyncedAt: string | null;
  /** Payer organization the contractor works for (from /people/me). */
  deelOrgName: string | null;
  contractorCountry: string | null;
  /** Present only when the granted scopes expose it. */
  deelUserEmail: string | null;
  lastError: string | null;
}

export interface DeelPollResult {
  scanned: number;
  created: number;
  autoIssued: number;
}

export async function getDeelStatus(): Promise<DeelStatus> {
  const { data } = await apiClient.get<DeelStatus>("/integrations/deel/status");
  return data;
}

/** "Sincronizar ahora" — poll for newly issued Deel invoices. */
export async function triggerDeelSync(): Promise<{
  enqueued: boolean;
  result?: DeelPollResult;
}> {
  const { data } = await apiClient.post<{
    enqueued: boolean;
    result?: DeelPollResult;
  }>("/integrations/deel/sync", {});
  return data;
}

/** "Importar facturas de Deel" — one-shot historical backfill (as drafts). */
export async function triggerDeelImport(): Promise<{
  enqueued: boolean;
  result?: DeelPollResult;
}> {
  const { data } = await apiClient.post<{
    enqueued: boolean;
    result?: DeelPollResult;
  }>("/integrations/deel/import", {});
  return data;
}

export async function startDeelOAuth(): Promise<{ url: string }> {
  const { data } = await apiClient.get<{ url: string }>(
    "/integrations/deel/authorize",
  );
  return data;
}

export async function disconnectDeel(): Promise<{ disconnected: true }> {
  const { data } = await apiClient.post<{ disconnected: true }>(
    "/integrations/deel/disconnect",
    {},
  );
  return data;
}
